import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableInvoiceWrap = Loadable({
  loader: function loader() {
    return import('../InvoiceWrap.jsx');
  },
  loading: ComponentLoading
});
export default LoadableInvoiceWrap;